import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();

  const handleStart = () => {
    navigate('/profile');
  };

  return (
    <div className="landing-container">
      <div className="parallax-background"></div>
      <div className="landing-content">
        <h1 className="headline">Unleash Elite Digital Expertise for Your Next Project</h1>
        <button className="cta-button" onClick={handleStart}>
          Start Your Journey
        </button>
      </div>
    </div>
  );
};

export default LandingPage;